import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../App.css";
import apiSgt from "../../services/apiSgtWeb";
import api from "../../services/api";
import { useHistory } from "react-router-dom";
import "./notfoundpage.scss";
import Logo from "../../assets/trimap-logo.jpg";
import ambiente from "../../services/ambiente";

const NotFoundPage = () => {
  const [prefeituras, setPrefeituras] = useState([]);
  const history = useHistory();

  useEffect(() => {
    const source = axios.CancelToken.source();

    apiSgt
      .get("/prefeituras/lookup-portal", {
        cancelToken: source.token,
      })
      .then((response) => {
        if (response.status === 200 && response.data !== undefined) {
          console.log(response.data);
          setPrefeituras(response.data);
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
        } else {
          throw err;
        }
      });
    return () => {
      source.cancel();
    };
  }, []);

  function pushPage(target) {

    console.log("target", target, "value", target.value);
    
    if (target.value) {
      const prefeituraData = target.value.split(",");
      localStorage.setItem("municipioId", prefeituraData[1]);
      history.replace(`/${prefeituraData[0]}/`);
      window.location.reload();
    }
  }

  return (
    <React.Fragment>
      <div className={"content-block dx-card responsive-paddings notfound"}>
        <div className="card-content">
          <img src={Logo} alt="TRIMAP" className="logo" />
          {ambiente.producao ? null : (
            <h3>{"Ambiente " + ambiente.nomeAmbiente}</h3>
          )}
          <h3>Prefeitura não encontrada</h3>
          Não foi possível localizar uma prefeitura nesse endereço. Abaixo segue
          a lista de nossas prefeituras:
          <select
            className={"select-box"}
            placeholder="Escolha uma Prefeitura"
            onChange={({ target }) => pushPage(target)}
          >
            <option value="">Selecione uma prefeitura</option>
            {prefeituras.length > 0
              ? prefeituras.map((x) => {
                return (
                  <option
                    key={x.id}
                    value={[x.codigoPortal, x.codigoIbge]}
                  >
                    {x.nome}
                  </option>
                );
              })
              : null}
          </select>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NotFoundPage;
